import { v4 as uuidv4 } from "uuid";
export class ClientOpportunityModel {
    constructor() {
        this.id = uuidv4();
        this.clientId = "";
        this.opportunityDate = null;
        this.opportunityDateAsString = "";
        this.description = "";
        this.createdOn = null;
        this.createdBy = "";
        this.createdByName = "";
        this.createdByImageURL = "";
        this.modifiedOn = null;
        this.modifiedBy = null;
    }
}
export default class ClientOpportunity extends ClientOpportunityModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
